<template>
  <div id="app-page" v-if="appReady">
    <!-- Our header is only for logged in users, it requests data specific to a user -->
    <AppHeader v-if="!route.meta.publicPage"/>
    <router-view id="app-view"/>
  </div>
  <ToastManager/>
  <Usersnap/>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import AppHeader from "@/components/base-components/header/AppHeader.vue";
  import ToastManager from "@/components/base-components/ToastManager.vue"
  import Usersnap from "@/components/base-components/Usersnap.vue";
  import { useUserStore } from "@/stores/userStore.js";
  import { prefersV3, redirectToV3 } from "@/js-modules/preferV3.js";

  const userStore = useUserStore()

  const router = useRouter()
  const route = useRoute()

  const appReady = ref(false)

  onMounted(async () => {
    // we can't access route information until the router is ready
    await router.isReady()

    // Opted into React (/v3): send home visits there before Vue renders.
    if (prefersV3() && route.path === "/") {
      redirectToV3()
      return
    }

    // On page refresh this checks the backend to see if the backend recognizes that we're signed in
    if (route.meta.publicPage) {
      appReady.value = true
    } else {
      await userStore.fetchCurrentUser()
      if (userStore.userId) {
        appReady.value = true
      } else {
        await router.push({ name: 'login' })
        appReady.value = true
      }
    }
  })
</script>

<style scoped lang="scss">
  #app-page {
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  #app-header {
    flex: 0 0 auto;
  }
  #app-view {
    flex: 1 1 auto;
    overflow-x: hidden;
    overflow-y: auto;
  }
  #app-footer {
    flex: 0 0 auto;
  }
</style>
